export default "__VITE_ASSET__C6_tT16E__"